import {useEffect, useState} from "react";

import {LinkedPatient} from "liberty-core/api/models";

import {getSessionStorageOrDefault, saveSessionStorage} from "lib/storage";

export const CURRENT_PATIENT_ID_KEY = "currentPatientId";

export default function useCurrentPatientId(possiblePatients: LinkedPatient[]) {
  const [selectedPatientId, setSelectedPatientId] = useState<string | null>(
    null,
  );

  useEffect(() => {
    const id = getSessionStorageOrDefault(CURRENT_PATIENT_ID_KEY, undefined);
    if (id && possiblePatients.find((p) => p.patientId === id)) {
      setSelectedPatientId(id);
    } else if (id) {
      saveSessionStorage(CURRENT_PATIENT_ID_KEY, undefined);
    }
  }, [possiblePatients]);

  function updateSelectedPatientId(id: string | null) {
    setSelectedPatientId(id);
    if (!id) {
      saveSessionStorage(CURRENT_PATIENT_ID_KEY, undefined);
    } else {
      saveSessionStorage(CURRENT_PATIENT_ID_KEY, id);
    }
  }

  return {selectedPatientId, updateSelectedPatientId};
}
